<template>
  <div class="container">
    <Title></Title>
    <div class="box">
      <advertisement />

      <div class="banner">
        <img src="https://www.lljrtj.com/images/logo.png" alt="" srcset="">
        <p>醴陵市金融纠纷调解中心</p>
      </div>
      <van-form @submit="onSubmit">
        <van-field v-model="username" name="姓名" label="姓名:" :rules="[{ required: true, message: '请填写姓名' }]" />
        <van-field v-model="telephone" name="联系电话" label="联系电话:" :rules="[{ required: true, message: '请填写联系电话' }]" />
        <van-field v-model="id" name="身份证号" label="身份证号:" :rules="[{ required: true, message: '请填写身份证号' }]" />
        <van-field v-model="content" name="调解事由" label="调解事由:" :rules="[{ required: true, message: '请填写调解事由' }]" />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
    <copyright />
  </div>
</template>

<script>
import Title from '../components/title.vue'
import copyright from "../components/copyright.vue";
import axios from 'axios';
import { Dialog, Notify } from 'vant';

export default {
  components: {
    Title,
    copyright
  },
  data() {
    return {
      username: '',
      telephone: '',
      id: '',
      content: ""
    }
  },
  methods: {
    // 校验函数返回 true 表示校验通过，false 表示不通过
    // onSubmit(values) {
    //   console.log('submit', values);
    // },
    async onSubmit() {
      let res = await axios.post('/api/apply/add', {
        id_number: this.id,
        contact_mobile: this.telephone,
        username: this.username,
        reason: this.content,
        platform: 'mobile',
        status: '1'
      })
      if (res.data.code == 1) {
        Dialog({ message: res.data.data });
      } else {
        Notify({ type: 'danger', message: '\n' + '\n' + res.data.message });
      }
      console.log(res.data);
    }
  },
}
</script>

<style scoped>
.box {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 3rem 0 0 0;
}


/* p {
  width: 100%;
  height: 13.5rem;
  border-radius: 0.5rem;
  margin-top: 2.375rem;
  position: relative;
} */


.banner {
  width: 100%;
  background: #dd3d43;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.banner>img {
  margin-top: 1rem;
  width: 9rem;
  height: 8rem;
  /* 对图片进行剪切，保留原始比例：*/
  object-fit: cover;
}

.banner>p {
  font-size: 1.2rem;
  font-weight: bold;
  margin: 1rem 0;
  color: #f6f9fc;
}
</style>



// WEBPACK FOOTER //
// src/page/application.vue